import { Surface } from '@payments-checkout/shared/components';
import jadeTheme from '@stone-payments/jade-design-tokens/cjs/stone';
import styled from 'styled-components';

export const AddressContainer = styled(Surface)`
  display: flex;
  flex-direction: column;
  gap: ${jadeTheme.global.space[300]};
  max-width: 464px;
`;

export const GridContainer = styled.div`
  display: grid;
  width:100%;
  grid-template-columns: 1fr 1fr;
  align-items: stretch;
  gap: ${jadeTheme.global.space[200]};

  @media (max-width: 500px) {
    grid-template-columns: 1fr;
  }
`;

export const GridItem = styled.div`
  width: 100%;
  overflow: auto;
`;

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${jadeTheme.global.space[300]};
`;
